import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选多个热门专题深度汇总，一站式浏览最全吃瓜内容合集
          </p>
        </div>

        <div className="space-y-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col md:flex-row gap-5 md:gap-8 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="w-full md:w-72 lg:w-80 flex-shrink-0 aspect-video md:aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col justify-center min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  查看专题
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}